import FooterLanguageSelect from './footer-language-select.component';
import { SELECT_LANGUAGE_ANALYTICS_ATTRIBUTES } from './footer-language-select.constants';

export default FooterLanguageSelect;
export { SELECT_LANGUAGE_ANALYTICS_ATTRIBUTES };
